module.exports = __webpack_public_path__ + "static/img/enabled_gisaid_grey.6c2ed4ea.png";